// A2 Level Aggregator - Elementary
// Tüm A2 ünite içeriklerini birleştirir

import { A2_UNIT_1 } from './kariyerContentsA2Unit1';
import { A2_UNIT_2 } from './kariyerContentsA2Unit2';
import { A2_UNIT_3 } from './kariyerContentsA2Unit3';
import { A2_UNIT_4 } from './kariyerContentsA2Unit4';
import { A2_UNIT_5 } from './kariyerContentsA2Unit5';
import { A2_FINAL } from './kariyerContentsA2Final';

export const A2_LEVEL = {
  ...A2_UNIT_1,  // Past Simple - Olumlu
  ...A2_UNIT_2,  // Past Simple - Olumsuz ve Soru
  ...A2_UNIT_3,  // Future - Will & Going to
  ...A2_UNIT_4,  // Comparatives & Superlatives
  ...A2_UNIT_5,  // Modal Verbs (must, should, have to)
  ...A2_FINAL,   // Final Sınavı
};

export default A2_LEVEL;
